import { inject, ModuleWithProviders, NgModule } from '@angular/core';

import { MetaLoader, MetaStaticLoader } from './meta.loader';
import { MetaService } from './meta.service';

export const metaFactory = () => new MetaStaticLoader();

@NgModule()
export class MetaModule {
  static forRoot(
    configuredProvider: any = {
      provide: MetaLoader,
      useFactory: metaFactory,
    },
  ): ModuleWithProviders<MetaModule> {
    return {
      ngModule: MetaModule,
      providers: [configuredProvider, MetaService],
    };
  }
  parentModule = inject(MetaModule, { optional: true, skipSelf: true });
  constructor() {
    if (this.parentModule) {
      throw new Error('MetaModule already loaded; import in root module only.');
    }
  }
}
